import React from 'react';

import { Heading, Projects } from '../../../components';



const ProjectSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Projects'} subTitle={'Innovation Meets Impact'} />

      {/* Projects Component */}
      <Projects />

    </section>

  );
}

export default ProjectSection;